//一键呼叫弹框
export const SETTING_CALL_PROMPT = "event/SETTING_CALL_PROMPT";

//支持记录弹框
export const SETTING_SUPPORT_RECORD = "event/SETTING_SUPPORT_RECORD"
 